import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=7bb42b94&scoped=true"
import script from "./Competitors.vue?vue&type=script&lang=js"
export * from "./Competitors.vue?vue&type=script&lang=js"
import style0 from "./Competitors.vue?vue&type=style&index=0&id=7bb42b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb42b94",
  null
  
)

export default component.exports